import { ActionInfoModel } from '../action-info.model';
import { ScopeCriteria } from '../data-entity-views';
import { DataEntrySourceModel } from '../data-entry-source';
import { ReportFormatEnum, ReportLayoutEnum } from '../enums';
import { FileModel } from '../file.model';
import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { AuthenticatedFormModel, PermissionModel } from '../permissions';
import { RefProperty } from '../ref-property.model';
import { StateHistoryModel } from '../state-history.model';
import { ApplicationSharingPresenter } from './application-sharing-presnter-model';
import { EntryHistoryPresenterModel } from './data-entry-presenter.model';

export class ReportPresenterModel {
  creationInfo?: ActionInfoModel;
  dataEntity: string;
  history?: Array<EntryHistoryPresenterModel>;
  id?: string;
  permissions?: Array<PermissionModel>;
  specificationVersion: number;
  state: 0 | 1 | 2;
  stateHistory?: Array<StateHistoryModel>;
  updateInfo?: ActionInfoModel;
  value: ReportEntryValuePresenterModel;
}

export class ReportEntryValuePresenterModel {
  authenticated?: null | AuthenticatedFormModel;
  dataSource?: DataEntrySourceModel;
  description?: LocalizedValueModel;
  fields?: Array<string>;
  icon?: IconModel;
  isPublished?: boolean;
  allowChangeFields?: boolean;
  name: LocalizedValueModel;
  relatedTo?: RefProperty;
  displayOrder?: number;
  schedule?: ReportScheduleModel;
  emailNotification?: SendReportEmailActionOptionsModel;
  design?: ReportDesignOptions;
  domain?: RefProperty;
  sharing: ApplicationSharingPresenter;
  help?: {
    contextualHelp?: LocalizedValueModel;
  };
}

export interface ReportDesignOptions {
  layout: ReportLayoutEnum;
  organizationFooter?: boolean;
  organizationHeader?: boolean;
  pageFooter?: boolean;
  pageHeader?: boolean;
  reportFooter?: ReportHeaderFooterValue;
  reportHeader?: ReportHeaderFooterValue;
}
export interface ReportHeaderFooterValue {
  type: 0 | 1;
  value: string | FileModel;
}

export const authenticatedReports: ScopeCriteria = [
  { 'value.authenticated.enabled': true },
  { 'value.authenticated.isRestricted': false },
];
export const RestrictedReports: ScopeCriteria = [
  { 'value.authenticated.isRestricted': true },
];

export class SendReportEmailActionOptionsModel {
  bccRecipients?: Array<ReportRecipientModel>;
  ccRecipients?: Array<ReportRecipientModel>;
  link?: EmailLinkModel;
  attachment?: EmailAttachmentModel;
  /**
   * The notification type to use in case of UUID or NotificationTypeValue in case of custom.
   */
  template: any;
  toRecipients?: Array<ReportRecipientModel>;
  tokensMap: {};
}

export class ReportRecipientModel {
  source: ReportRecipientSource;
  sourceType: 0 | 1 | 2 | 3 | 4;
}

export class ReportRecipientSource {
  type: 0;

  /**
   * Either (a reference property to user or group in case of fixed) or (a field normalized name in case of dynamic)
   * In case it is a relative owner the value will be the step id which will the owner be relative to it and the owner will be calculated based on user org_unit
   */
  value: any;
}

export class EmailLinkModel {
  /**
   * Whether the link should be added in the body or not.
   */
  enabled?: boolean;

  /**
   * The view id to use for link to show the details of the entry related to the trigger
   */
  viewId?: string;
}

export class EmailAttachmentModel {
  /**
   * Add the report as an attachment to the email.
   */
  enabled: boolean;
  /**
   * The type of the attachment. Either PDF or CSV
   */
  type: ReportFormatEnum;
}

export interface ReportScheduleModel {
  oneTime?: string | null;
  repeat?: ReportTriggerRepeatModel;
  enabled: boolean;
}

export interface ReportTriggerRepeatModel {
  /**
   * can be a human-readable format String, or a cron format String
   */
  expression?: string;
  options?: ReoportTriggerRepeatOptionsModel;
}

export interface ReoportTriggerRepeatOptionsModel {
  /**
   * should be a string as accepted by moment-timezone and is considered when using an interval in the cron string format.
   */
  timezone?: string;

  /**
   * the first time the job runs, should be equal or after the start date.
   */
  startDate?: string;

  /**
   * the job should not repeat after the endDate. The job can run on the end-date itself, but,
   */
  endDate?: string;
}
